<template>
  <Layout>
    <div id="billing-details-view" class="flex">
      <transition name="fade">
        <div v-if="showLoaderOverlay"
             class="fixed inset-0 flex items-center justify-center z-30 bg-onvocado-white bg-opacity-75">
          <Loader></Loader>
        </div>
      </transition>
      <div class="container">
        <template v-if="!getPlansCompleted && !getUserCompleted">
          <Loader></Loader>
        </template>

        <template v-else>
          <template v-if="hasPaidSubscription">
            <section class="mb-8 lg:mb-16">
              <current-subscription-overview :current-plan="currentUserPlan"
                                             :has-canceled-subscription="hasCanceledSubscription"
                                             @subscription-change="triggerChangeSubscription"
                                             @subscription-renew="triggerRenewSubscription"/>
            </section>

            <section>
              <h3 class="mb-4">Available Plans</h3>
              <plans-preview-component
                  :default-currency="currentUserPlan.currency"
                  :show-billing-period="hasCanceledSubscription && !hasPaidSubscription"
                  :default-billing-period="currentUserPlan.billingPeriod"
                  @subscription-change="triggerChangeSubscription"
                  @subscription-cancel="triggerCancelSubscription"
                  @subscription-renew="triggerRenewSubscription"/>
            </section>

            <!--            <section>-->
            <!--              <h3 class="mb-4">Invoices</h3>-->
            <!--              <invoices-overview v-if="getPlansCompleted"/>-->
            <!--            </section>-->
          </template>

          <template v-else>
            <h3 class="mb-4">Subscription</h3>
            <span>Currently you have no subscription.</span>
            <br/>
            <br/>
            <router-link :to="{ name: 'billing' }">
              <button class="btn secondary" type="button">Available Plans</button>
            </router-link>
          </template>
        </template>
      </div>

      <!--      <cancel-plan-modal-component :cancel-plan-modal-visible="cancelPlanModalVisible"-->
      <!--                                   @close-modal="cancelPlanModalVisible = false"/>-->

      <!--      <change-plan-modal-component :change-plan-modal-visible="changePlanModalVisible"-->
      <!--                                   @close-modal="changePlanModalVisible = false"/>-->
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main.vue'
import { mapActions, mapState } from 'vuex'
import PlansPreview from '@components/Payment/PlansPreview/PlansPreview.vue'
import CurrentSubscriptionOverview from '@components/Payment/CurrentSubscriptionOverview.vue'
// import InvoicesOverview from '@components/Payment/InvoicesOverview.vue'
// import ChangePlanModal from '@components/modals/ChangePlanModal/ChangePlanModal.vue'
// import CancelPlanModal from '@components/modals/CancelPlanModal/CancelPlanModal.vue'

export default {
  page: {
    title: 'Billing Details',
    meta: [{ name: 'description', content: 'BillingDetails' }],
  },
  name: 'BillingDetailsView',
  components: {
    Layout,
    'plans-preview-component': PlansPreview,
    'current-subscription-overview': CurrentSubscriptionOverview,
    // 'invoices-overview': InvoicesOverview,
    // 'change-plan-modal-component': ChangePlanModal,
    // 'cancel-plan-modal-component': CancelPlanModal,
  },
  data() {
    return {
      showLoaderOverlay: false,
      // changePlanModalVisible: false,
      // cancelPlanModalVisible: false,
    }
  },
  computed: {
    ...mapState({
      currentUserPlan: (state) => state.users.currentUser.subscription,
      getUserCompleted: (state) => state.users.getUserCompleted,
      getPlansCompleted: (state) => state.plans.getPlansCompleted,
    }),
    hasPaidSubscription() {
      return this.$store.getters['users/hasPaidSubscription']
    },
    hasCanceledSubscription() {
      return this.$store.getters['users/hasCanceledSubscription']
    },
  },
  methods: {
    ...mapActions('users', ['getAccountDetails']),
    ...mapActions('subscription', [
      'setChosenSubscriptionID',
      'generateCustomerPortalSession',
      'voidCancellation',
    ]),
    generateAndRedirect(type, stripePriceId = null) {
      this.showLoaderOverlay = true
      const payload = {
        return_url: window.location.origin + '/settings/billing',
        stripe_price_id: stripePriceId,
        type,
      }

      this.generateCustomerPortalSession(payload).then((data) => {
        if (data.url) {
          window.location.href = data.url
        } else {
          console.error('Error creating customer portal session:', data.error)
        }
      })
    },
    triggerChangeSubscription(planID, stripePriceId) {
      this.setChosenSubscriptionID(planID)
      this.generateAndRedirect('subscription_update', stripePriceId)
    },
    triggerCancelSubscription() {
      this.setChosenSubscriptionID('basic')
      this.generateAndRedirect('subscription_cancel')
    },
    triggerRenewSubscription() {
      this.showLoaderOverlay = true
       this.voidCancellation().then((data) => {
         this.getAccountDetails().then(() => {
           this.showLoaderOverlay = false
           this.$message({
              type: 'success',
              message: 'Subscription successfully renewed.',
            })
        }).catch(() => {
          this.showLoaderOverlay = false
           this.$message({
            type: 'error',
            message: 'Failed to renew subscription. Please contact support.',
          })
         })
      })
    },
  },
}
</script>